import React,{useEffect} from 'react';
import { Table, Button } from 'antd';
import dayjs from 'dayjs'; // Add this import

// Helper to check if two time ranges overlap (all "HH:mm")
function isTimeRangeOverlap(start1, end1, start2, end2) {
  const toMinutes = t => {
    if (!t || typeof t !== 'string' || !/^\d{2}:\d{2}$/.test(t)) return NaN;
    const [h, m] = t.split(':').map(Number);
    return h * 60 + m;
  };
  const s1 = toMinutes(start1), e1 = toMinutes(end1);
  const s2 = toMinutes(start2), e2 = toMinutes(end2);
  if ([s1, e1, s2, e2].some(isNaN)) return false;
  return s1 < e2 && s2 < e1;
}



const columns = [
  // {
  //   title: '',
  //   dataIndex: 'checked',
  //   key: 'checked',
  //   width: 40,
  //   render: () => (
  //     <span style={{
  //       display: 'inline-block',
  //       width: 18,
  //       height: 18,
  //       border: '1.5px solid #1677ff',
  //       borderRadius: 4,
  //       background: '#1677ff',
  //       marginLeft: 4,
  //       marginRight: 4,
  //       verticalAlign: 'middle',
  //       position: 'relative'
  //     }}>
  //       <svg width="12" height="12" style={{ position: 'absolute', top: 2, left: 2 }}>
  //         <polyline points="1,7 5,11 11,1" style={{ fill: 'none', stroke: '#fff', strokeWidth: 2 }} />
  //       </svg>
  //     </span>
  //   ),
  // },
  { title: 'Sl. no.', dataIndex: 'key', key: 'key', width: 60 },
  { title: 'Employee Name', dataIndex: 'name', key: 'name', width: 180 },
  { title: 'Employee ID', dataIndex: 'id', key: 'id', width: 120 },
  { title: 'Union', dataIndex: 'union', key: 'union', width: 120 },
  { title: 'SSN4', dataIndex: 'ssn4', key: 'ssn4', width: 100 },
  { title: 'Task', dataIndex: 'task', key: 'task', width: 120 },
];

const ScheduleStatus = ({
  assignedEmployees = [],
  crewAssignments = [],
  assignDate,
  onOverride,
  onCancel,
  successToAssign = [],
  conflictToAssign = [],
}) => {

  // Format assignDate as DD-MM-YYYY
  const formattedAssignDate = assignDate
    ? dayjs(assignDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('DD-MM-YYYY')
    : '';


  
  

  const exceptionEmployees = conflictToAssign.map((emp, idx) => ({
    ...emp,
    key: idx + 1,
  }));
  const successEmployees = successToAssign.map((emp, idx) => ({
    ...emp,
    key: idx + 1,
  }));


 

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', background: '#fff', borderRadius: 12, padding: 32 }}>
      <div style={{ fontSize: 22, fontWeight: 600, textAlign: 'center', marginBottom: 32 }}>
        Schedule status
      </div>
      {/* Success */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          borderRadius: '50%',
          background: '#eaf2ff',
          color: '#1677ff',
          fontSize: 20,
          marginRight: 12,
        }}>
          <svg width="20" height="20" viewBox="0 0 20 20">
            <circle cx="10" cy="10" r="10" fill="#eaf2ff" />
            <polyline points="5,11 9,15 15,7" style={{ fill: 'none', stroke: '#1677ff', strokeWidth: 2 }} />
          </svg>
        </span>
        <div style={{ fontWeight: 500, color: '#1677ff', fontSize: 16 }}>
          Success
        </div>
      </div>
      <div style={{ marginLeft: 44, color: '#222', fontSize: 15, marginBottom: 20 }}>
        {successEmployees.length} Employees are scheduled successfully in “{formattedAssignDate}”.
      </div>
      {/* Exceptions */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8, marginTop: 24 }}>
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
          borderRadius: '50%',
          background: '#ffeaea',
          color: '#ff4d4f',
          fontSize: 20,
          marginRight: 12,
        }}>
          <svg width="20" height="20" viewBox="0 0 20 20">
            <circle cx="10" cy="10" r="10" fill="#ffeaea" />
            <line x1="7" y1="7" x2="13" y2="13" stroke="#ff4d4f" strokeWidth="2" />
            <line x1="13" y1="7" x2="7" y2="13" stroke="#ff4d4f" strokeWidth="2" />
          </svg>
        </span>
        <div style={{ fontWeight: 500, color: '#ff4d4f', fontSize: 16 }}>
          Exceptions
        </div>
      </div>
      <div style={{ marginLeft: 44, color: '#222', fontSize: 15, marginBottom: 16 }}>
        {exceptionEmployees.length} Employees are exceptions, click “Override Schedule” to Unschedule these workmen from current schedule and assign them to below schedule
      </div>
      <Table
        columns={columns}
        dataSource={exceptionEmployees}
        pagination={false}
        bordered
        rowSelection={{
          type: 'checkbox',
          defaultSelectedRowKeys: exceptionEmployees.map(e => e.key),
        }}
        style={{ marginBottom: 32 }}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
        <Button style={{ minWidth: 120 }} size="large" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          size="large"
          style={{ minWidth: 180 }}
          onClick={onOverride}
          disabled={exceptionEmployees.length === 0} // Disable if no exceptions
        >
          Override Schedule
        </Button>
      </div>
    </div>
  );
};

export default ScheduleStatus;

